<p class="header">{{ 'stt.downloadW.word' | translate }}</p>
<div class="content">
    <div class="col md-12">
        <span class="material-icons sound">
        get_app
        </span> 
    </div>
    <p>{{ 'stt.downloadW.down' | translate }}</p>
    <P>{{ 'stt.downloadW.confirm' | translate }}</P>

    <div class="buttons-box">
        <a class="button-primary no" (click)="closeModal()" mat-dialog-close>{{ 'stt.downloadW.not' | translate }}</a>
        <a class="button-primary" (click)="handlerDownload()" mat-dialog-close>{{ 'stt.downloadW.yes' | translate }}</a>
    </div>    
</div>
